// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"2059f318","703":"c1eb853b","787":"90924a69"}[chunkId] + ".chunk.js";
};